export default __webpack_public_path__ + "static/media/noImageAvailable.a33b48dd.jpeg";